var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9998 15.1998C4.02808 15.1998 0.799805 11.9715 0.799805 7.9998C0.799805 4.02808 4.02808 0.799805 7.9998 0.799805C11.9715 0.799805 15.1998 4.02808 15.1998 7.9998C15.1998 11.9715 11.9715 15.1998 7.9998 15.1998ZM7.9998 1.80446C4.58399 1.80446 1.80446 4.58399 1.80446 7.9998C1.80446 11.4156 4.58399 14.1952 7.9998 14.1952C11.4156 14.1952 14.1952 11.4156 14.1952 7.9998C14.1952 4.58399 11.4156 1.80446 7.9998 1.80446ZM6.10427 10.3975C5.97701 10.3975 5.84976 10.3506 5.74929 10.2501C5.55506 10.0559 5.55506 9.73441 5.74929 9.54018L7.28976 7.99971L5.74929 6.45925C5.55506 6.26501 5.55506 5.94353 5.74929 5.74929C5.94353 5.55506 6.26501 5.55506 6.45925 5.74929L7.99971 7.28976L9.54018 5.74929C9.73441 5.55506 10.0559 5.55506 10.2501 5.74929C10.4444 5.94353 10.4444 6.26501 10.2501 6.45925L8.70966 7.99971L10.2501 9.54018C10.4444 9.73441 10.4444 10.0559 10.2501 10.2501C10.1497 10.3506 10.0224 10.3975 9.89515 10.3975C9.7679 10.3975 9.64064 10.3506 9.54018 10.2501L7.99971 8.70967L6.45925 10.2501C6.36548 10.3506 6.23153 10.3975 6.10427 10.3975Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.29040791179e273f35a5456e48a1407c.svg";
export { ForwardRef as ReactComponent };